// extracted by mini-css-extract-plugin
module.exports = {"LoginDiv":"Login_LoginDiv__fE9eU","Success":"Login_Success__1OGae","Failure":"Login_Failure__1c9mi","LoginForm":"Login_LoginForm__3hzOE","LoginButton":"Login_LoginButton__1H3an"};